
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/blogs",
      function () {
        return require("private-next-pages/[publicId]/blogs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/blogs"])
      });
    }
  